module.exports = __webpack_public_path__ + "img/importantNoticesCarouselImage.6613863a.png";